import Swal from 'sweetalert2'

import { lang } from '../../assets/lang'
import CONST_SOCKET from '../../const/socket'
import CONST_COMPONENT from '../../const/component'
import { newPostbackHtml } from './newPostbackHtml'
import { 
  sweetAlertCommonParams,
  selectedOptionsTextArray, 
  createSelect2DynamicOption,
  getNodeInputConnectionsBySocketName, 
} from '../../utils/functions'

var page_table_id = window.xitFlowBuilderData.page_table_id
var base_url = window.xitFlowBuilderData.base_url
var instagram_bot_addon = window.xitFlowBuilderData.instagram_addon
const isSequenceAddonAvailable = !! window.xitFlowBuilderData.sequence_addon

export const newPostbackModal = async (oldData, node) => {
  const commonParams = sweetAlertCommonParams(node)

  return await Swal.fire({
    ...commonParams,
    title: lang.postback_new_modal_title,
    html: newPostbackHtml(),
    willOpen: () => {
      $('.select2').select2({ 
        width: '100%',
        dropdownParent: $('#swal2-content')
      })

      const elementLabel = $('#new-postback-choose-label')
      createSelect2DynamicOption(elementLabel)
      
      if (isSequenceAddonAvailable) {
        hideElementsIfSequenceSingleIsConnected(node)
      }

      $.ajax({
        type: 'POST',
        url: base_url+'visual_flow_builder/get_label_sequence_dropdown',
        dataType: 'JSON',
        data: { page_table_id, requested_from: 'new_postback', instagram_bot_addon },
        success:function(response) {
          $("#new-postback-choose-label").html(response.label_dropdown);
          $("#new-postback-choose-sequence").html(response.drip_dropdown);

          $('#new-postback-choose-label').val(oldData.labelIds || '').trigger('change')

          if (isSequenceAddonAvailable) {
            $('#new-postback-choose-sequence').val(oldData.sequenceIdValue || '').trigger('change')
          }
        }
      })

      $('#new-postback-postback-title').val(oldData.title || '')
      $('#new-postback-choose-label').val(oldData.labelIds || '').trigger('change')

      if (isSequenceAddonAvailable) {
        $('#new-postback-choose-sequence').val(oldData.sequenceIdValue || '').trigger('change')
  
        $('#new-postback-choose-sequence').on('change', function() {
          Swal.resetValidationMessage()
          const currentValue = $(this).val()
          if ('newSequence' === oldData.sequenceIdValue && 'newSequence' !== currentValue) {
            node.newPostbackNodeNewSequenceValueChangeStatus = true;
            Swal.showValidationMessage(lang.postback_new_html_info_sequence)
          }
        })
      }

      $('[data-toggle="tooltip"]').tooltip()
    },

    preConfirm: () => {
      const title = $('#new-postback-postback-title').val()

      const labelIds = $('#new-postback-choose-label').val()
      const labelIdTexts = $('#new-postback-choose-label option:selected')
      const labelIdTextsArray = selectedOptionsTextArray(labelIdTexts) 

      const data = {
        title,
        labelIds,
        labelIdTextsArray,
      }
      
      if (isSequenceAddonAvailable) {
        const sequenceIdValue = $('#new-postback-choose-sequence').val()
        const sequenceIdText = $('#new-postback-choose-sequence option:selected').text()

        data['sequenceIdValue'] = sequenceIdValue
        data['sequenceIdText'] = sequenceIdText
      }
      
      if (! title) {
        Swal.showValidationMessage(lang.postback_new_modal_msg_title)
      }
      
      return { ...data }
    },
  })
}

const hideElementsIfSequenceSingleIsConnected = (node) => {
  const connections = getNodeInputConnectionsBySocketName(CONST_SOCKET.NEW_POSTBACK_INPUT, node)
  if (connections[0]) {
    const nodeConnectedAsOutput = connections[0].output.node
    if  ((nodeConnectedAsOutput.name === CONST_COMPONENT.SEQUENCE_SINGLE) ||
          (nodeConnectedAsOutput.name === CONST_COMPONENT.OTN_SINGLE) ||
          (nodeConnectedAsOutput.name === CONST_COMPONENT.RCN_SINGLE)
        ) 
        {
          $('.new-postback-hidable-field').parent().removeClass('d-block').addClass('d-none')
        }
  }
}